// root/frontend/src/Modal/ModalContents.jsx
import React, { useState } from "react";
import { useModal } from "../context/modalContext";
import styles from "./ModalContent.module.css";

// Get API base URL from environment
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const ContactUsContent = () => (
  <div className={styles.modalBody}>
    <div className={styles.modalHeader}>
      <h2>Contact Us</h2>
    </div>
    <div className={styles.modalContent}>
      <p>We'd love to hear from you! Get in touch with our team.</p>

      <div className={styles.contactInfo}>
        <div className={styles.contactItem}>
          <h4>Email</h4>
          <p>jigyasa.ai.hindi@gmail.com</p>
        </div>
        <div className={styles.contactItem}>
          <h4>Address</h4>
          <p>Singapore</p>
        </div>
        <div className={styles.contactItem}>
          <h4>Business Hours</h4>
          <p>
            Monday - Friday: 9:00 AM - 5:00 PM
            <br />
            Saturday - Sunday: Closed
          </p>
        </div>
      </div>
    </div>
  </div>
);

export const SettingsContent = ({ isAuthenticated, userData }) => (
  <div className={styles.modalHeader}>
    <h3>Settings Coming soon.</h3>
  </div>
);

//COMMENTED SETTINGS AS IT WILL BE IMPLEMENTED LATER.
/*
export const SettingsContent = ({ isAuthenticated, userData }) => (
  <div className={styles.modalBody}>
    <div className={styles.modalHeader}>
      <h2>Settings</h2>
    </div>
    <div className={styles.modalContent}>
      {isAuthenticated ? (
        <>
          <div className={styles.settingSection}>
            <h3>Account Information</h3>
            <div className={styles.settingItem}>
              <label>Name:</label>
              <span>{userData?.name || "Not available"}</span>
            </div>
            <div className={styles.settingItem}>
              <label>Current Class:</label>
              <span>{userData?.class_name || "Not assigned"}</span>
            </div>
          </div>

          <div className={styles.settingSection}>
            <h3>Account Settings</h3>
            <button className={styles.settingButton}>Change Class</button>
            <button className={styles.settingButton}>
              Manage Subscription
            </button>
            <button className={styles.settingButton}>Update Profile</button>
          </div>

          <div className={styles.settingSection}>
            <h3>Preferences</h3>
            <div className={styles.settingItem}>
              <label>
                <input type="checkbox" /> Email Notifications
              </label>
            </div>
            <div className={styles.settingItem}>
              <label>
                <input type="checkbox" /> Progress Reports
              </label>
            </div>
          </div>
        </>
      ) : (
        <div className={styles.notLoggedIn}>
          <p>Please sign in to access settings.</p>
          <button
            className={styles.loginPromptButton}
            onClick={() =>
              (window.location.href = `${API_BASE_URL}/auth/login`)
            }
          >
            Sign in with Google
          </button>
        </div>
      )}
    </div>
  </div>
);*/

// NEW: Feedback Content Component
export const FeedbackContent = ({ isAuthenticated, userData }) => {
  const { closeModal } = useModal();
  const [formData, setFormData] = useState({
    feedbackText: "",
    starRating: 0,
    category: "general",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', null
  const [errors, setErrors] = useState({});

  const categories = [
    { value: "general", label: "General Feedback" },
    { value: "bug_report", label: "Bug Report" },
    { value: "feature_request", label: "Feature Request" },
    { value: "ui_ux", label: "UI/UX Feedback" },
    { value: "performance", label: "Performance Issue" },
  ];

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    // Clear errors when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.feedbackText.trim()) {
      newErrors.feedbackText = "Please enter your feedback";
    } else if (formData.feedbackText.trim().length < 10) {
      newErrors.feedbackText = "Feedback must be at least 10 characters long";
    }

    if (formData.starRating === 0) {
      newErrors.starRating = "Please select a rating";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  const detectDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/tablet|ipad|playbook|silk/.test(userAgent)) return "tablet";
    if (/mobile|android|iphone|ipod|blackberry|opera|mini/.test(userAgent))
      return "mobile";
    return "desktop";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const token = getAuthToken();

      const feedbackData = {
        feedbackText: formData.feedbackText.trim(),
        starRating: formData.starRating,
        category: formData.category,
        pageURL: window.location.href,
        userAgent: navigator.userAgent,
        deviceType: detectDeviceType(),
      };

      const response = await fetch("/api/feedback", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(feedbackData),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setSubmitStatus("success");
        // Reset form
        setFormData({
          feedbackText: "",
          starRating: 0,
          category: "general",
        });

        // Close modal after 2 seconds
        setTimeout(() => {
          closeModal();
        }, 2000);
      } else {
        throw new Error(result.message || "Failed to submit feedback");
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <div className={styles.modalBody}>
        <div className={styles.modalHeader}>
          <h2>Feedback</h2>
        </div>
        <div className={styles.modalContent}>
          <div className={styles.notLoggedIn}>
            <p>Please sign in to submit feedback.</p>
            <button
              className={styles.loginPromptButton}
              onClick={() =>
                (window.location.href = `${API_BASE_URL}/auth/login`)
              }
            >
              Sign in with Google
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.modalBody}>
      <div className={styles.modalHeader}>
        <h2>Share Your Feedback</h2>
      </div>
      <div className={styles.modalContent}>
        {submitStatus === "success" ? (
          <div className={styles.successMessage}>
            <div className={styles.successIcon}>✅</div>
            <h3>Thank you for your feedback!</h3>
            <p>
              Your feedback has been submitted successfully. We appreciate your
              input and will review it soon.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.feedbackForm}>
            {/* Category Selection */}
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Category <span className={styles.required}>*</span>
              </label>
              <select
                value={formData.category}
                onChange={(e) => handleInputChange("category", e.target.value)}
                className={styles.formSelect}
              >
                {categories.map((cat) => (
                  <option key={cat.value} value={cat.value}>
                    {cat.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Star Rating */}
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Rating <span className={styles.required}>*</span>
              </label>
              <div className={styles.starRating}>
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    className={`${styles.starButton} ${
                      star <= formData.starRating ? styles.starActive : ""
                    }`}
                    onClick={() => handleInputChange("starRating", star)}
                  >
                    ⭐
                  </button>
                ))}
                <span className={styles.ratingText}>
                  {formData.starRating > 0
                    ? `${formData.starRating}/5`
                    : "Select a rating"}
                </span>
              </div>
              {errors.starRating && (
                <div className={styles.errorMessage}>{errors.starRating}</div>
              )}
            </div>

            {/* Feedback Text */}
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Your Feedback <span className={styles.required}>*</span>
              </label>
              <textarea
                value={formData.feedbackText}
                onChange={(e) =>
                  handleInputChange("feedbackText", e.target.value)
                }
                placeholder="Please share your thoughts, suggestions, or report any issues you've encountered..."
                className={styles.feedbackTextarea}
                rows={6}
                maxLength={1000}
              />
              <div className={styles.charCount}>
                {formData.feedbackText.length}/1000 characters
              </div>
              {errors.feedbackText && (
                <div className={styles.errorMessage}>{errors.feedbackText}</div>
              )}
            </div>

            {/* User Info Display */}
            <div className={styles.userInfo}>
              <small>
                <strong>Submitting as:</strong> {userData?.name} (
                {userData?.email})
              </small>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className={`${styles.submitButton} ${
                isSubmitting ? styles.submitting : ""
              }`}
            >
              {isSubmitting ? "Submitting..." : "Submit Feedback"}
            </button>

            {submitStatus === "error" && (
              <div className={styles.errorMessage}>
                Failed to submit feedback. Please try again later.
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
};
